import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import { Section } from '@fiverr-private/fit';
import { createSourceInfo } from '../../../../shared/utils/bi';
import { BI_CONSTS } from '../../constants';
import { EXPLAINER_VIDEO } from '../../../../shared/constants';
import ExplanationVideo from '../../../../shared/components/Video/ExplanationVideo';
import './index.scss';

const Header = ({ category }) => {
    const sourceInfo = createSourceInfo({
        videoName: EXPLAINER_VIDEO.name,
        mixpanelPageName: BI_CONSTS.mixpanel.pageName,
        bigQueryPageName: BI_CONSTS.bigQuery.pageName
    });

    const { isTouch } = getContext();

    return (
        <Section className="header">
            <img src={category.backgroundImage} className={classNames('category-image', { 'desktop': !isTouch })} alt={category.title}/>
            <Section equalPadding className={classNames('inner flex-center', { 'desktop': !isTouch })}>
                <h1 className={classNames({ 'desktop': !isTouch })}>{category.title}</h1>
                <p className={classNames('subtitle', { 'desktop': !isTouch })}>{category.subtitle}</p>
                <ExplanationVideo hasVideoLink={false}
                    isCategoryPage
                    videoTitle={<I18n k="shared.how_fiverr_works"/>}
                    video={EXPLAINER_VIDEO}
                    sourceInfo={sourceInfo}/>
            </Section>
        </Section>
    );
};

Header.propTypes = {
    category: PropTypes.object
};

export default Header;
